import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';

const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE = 'cs_id_230';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Adición de acciones', listHelp: ['155'] }

];

const tableStructure = [
  { id: 'desc', title: 'Razon Social' },
  { id: 'origen', title: 'Origen Información' },
  { id: 'valDeclarar', title: 'Valor a declarar' }
];

class Form1 {
  id: number;
  desc: string;
  origen: string;
  anioCompra: string;
  valCompra: string;
  valDeclaradoAnioAnterior: string;
  valAjustadoArt70: string;
  valAjustadoArt73: string;
  valDeclarar: string;
  art: string;


  idSugerida: 0;
  reportante: string;

  aplicoArt73: string;


}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-patrimonio-acciones-modal',
  templateUrl: './patrimonio-acciones-modal.component.html',
  styleUrls: ['./patrimonio-acciones-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class PatrimonioAccionesModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: any[] = [];
  public lstAnios: number[] = [];

  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;

  saveModel = new EventEmitter();
  public showSave: boolean;
  anioDeclaracion: number;
  tablaArt73: any;
  model: DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema(basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  modoAdquisionList = [{ id: '1', nombre: "Compra/Venta" }, { id: '2', nombre: "Leasing" }];
  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<PatrimonioAccionesModalComponent>,
    private _sugeridaSingletonService: SugeridaSingletonService,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    console.log(this.model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();
    this.validateShowSave();
    //this.reloadSelArticulos();
    this.initializeAnios();
    console.log(this.model);

  }

  protected controlStep(direction: DirectionType): void {

  }

  protected inicializeForm() {
    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.desc = "";
    this.modelForm.origen = "";
    this.modelForm.anioCompra = "0";
    this.modelForm.valCompra = "0";
    this.modelForm.valDeclaradoAnioAnterior = "0";
    this.modelForm.valAjustadoArt70 = "0";
    this.modelForm.valAjustadoArt73 = "0";
    this.modelForm.valDeclarar = "0";


    this.modelForm.aplicoArt73 = "1";

    this.modelForm.origen = "";
    this.modelForm.idSugerida = 0;
    this.modelForm.reportante = "";

    this.reloadSelArticulos();
  }

  protected inicializeModelo() {
    this.anioDeclaracion = Number(this.model.doc.cab.cs_id_1);

    if (this.model.doc.cuerpo.cc_id_204 == undefined) {
      this.model.doc.cuerpo.cc_id_204 = [];
      this.model.doc.cuerpo.cc_id_205 = [];
      this.model.doc.cuerpo.cc_id_206 = [];
      this.model.doc.cuerpo.cc_id_207 = [];
      this.model.doc.cuerpo.cc_id_208 = [];
      this.model.doc.cuerpo.cc_id_209 = [];
      this.model.doc.cuerpo.cc_id_210 = [];
      this.model.doc.cuerpo.cc_id_211 = [];
      this.model.doc.cuerpo.cs_id_156 = this.model.doc.cuerpo.cs_id_156?this.model.doc.cuerpo.cs_id_156:"0";//suma valores de acciones
    }
  }

  protected reloadSelArticulos(conservarArt?: boolean) {//Dom 1649

    this.lstArticulos[0] = { valor: 0, nombre: "" };
    this.lstArticulos[1] = { valor: 2, nombre: "Valor de compra" };
    this.lstArticulos[2] = { valor: 3, nombre: "Valor declarado 2023" };
    this.lstArticulos[3] = { valor: 4, nombre: "Valor ajustado art. 70" };
    this.lstArticulos[4] = { valor: 5, nombre: "Valor ajustado art. 73" };

    this.lstArticulos = [];
    let i = 0;
    this.lstArticulos[i] = { valor: "0", nombre: "" };
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelForm.valCompra.toString(), "0")) {
      i++;
      this.lstArticulos[i] = { valor: this.modelForm.valCompra, nombre: ("Valor de compra: $" + this.modelForm.valCompra) };
    }
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelForm.valDeclaradoAnioAnterior.toString(), "0")) {
      i++;
      this.lstArticulos[i] = { valor: this.modelForm.valDeclaradoAnioAnterior, nombre: ("Valor declarado 2023: $" + this.modelForm.valDeclaradoAnioAnterior) };
    }
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelForm.valAjustadoArt70.toString(), "0")) {
      i++;
      this.lstArticulos[i] = { valor: this.modelForm.valAjustadoArt70, nombre: ("Valor ajustado art. 70: $" + this.modelForm.valAjustadoArt70) };
    }
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelForm.valAjustadoArt73.toString(), "0")) {
      i++;
      this.lstArticulos[i] = { valor: this.modelForm.valAjustadoArt73, nombre: ("Valor ajustado art. 73: $" + this.modelForm.valAjustadoArt73) };
    }

    if (!conservarArt) this.modelForm.art = "0";
  }

  protected initializeAnios() {

    this.lstAnios = this.tablaArt73
      .filter(item => item.anioGravable === "2023")
      .map(item => item.anio);
    // console.log(this.lstAnios);
  }

  public operacionCs156() {
    let suma = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valDeclarar, suma);
    }
    this.model.doc.cuerpo.cs_id_156 = suma;
  }

  public operaciones(numCas?: number, soloEstaCasilla?: boolean): void {
    switch (numCas) {
      case 158:
        this.operacionCS158();
        break;

    }
    if (soloEstaCasilla) return;

    //Operaciones
    let resultado = "0";

    this.reloadSelArticulos();

  }

  operacionCS158() {
    this.model.doc.cuerpo.cs_id_158 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_158, true);
  }


  //////////////////////

  protected initializeTablaDesdeModelo() {
    this.dataSourceBody = [];
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_204.length; i++) {
      this.modelForm.id = i;
      this.modelForm.desc = this.model.doc.cuerpo.cc_id_204[i].v;
      this.modelForm.origen = this.model.doc.cuerpo.cc_id_205[i].v;
      this.modelForm.anioCompra = this.model.doc.cuerpo.cc_id_206[i].v;
      this.modelForm.valCompra = this.model.doc.cuerpo.cc_id_207[i].v;
      this.modelForm.valDeclaradoAnioAnterior = this.model.doc.cuerpo.cc_id_208[i].v;
      this.modelForm.valAjustadoArt70 = this.model.doc.cuerpo.cc_id_209[i].v;
      this.modelForm.valAjustadoArt73 = this.model.doc.cuerpo.cc_id_210[i].v;
      this.modelForm.valDeclarar = this.model.doc.cuerpo.cc_id_211[i].v;

      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

  protected initializeTablaDesdeSugerida() {

    let indexModel = this.model.doc.cuerpo.cc_id_204.length;


    if (indexModel == 0) {

      const fieldsRecovery = [
        'VAR_2269',
        'VAR_3811'
        //Se eilimina variable por solicitud funcional 11-09-2024,
        //'VAR_2256_4'
      ];
      const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
      console.log(resData);

      if (resData) {

        for (let i = 0; i < resData.length; i++) {
          for (let j = 0; j < resData[i].item.value.length; j++) {

            this.modelForm.id = indexModel;
            // this.modelForm.desc = this.data.sugerida[i].desc;

            // this.modelForm.valDeclarar = this.data.sugerida[i].valDeclarar;
            this.modelForm.valCompra = String(resData[i].item.value[j]);

            this.modelForm.origen = "0";
            // this.modelForm.idSugerida = this.data.sugerida[i].idSugerida;
            // this.modelForm.reportante = this.data.sugerida[i].reportante;
            this.modelForm.desc = resData[i].item.numNitInformante[j] + "/" + resData[i].item.nomRazonSocialInformante[j];
            this.redondearFormData();
            this.dataSourceBody.push(this.modelForm);
            this.inicializeForm();
            indexModel++;
          }
        }
      }
    }
    this.operacionCs156();
  }


  public editModeloDesdeForm() {
    this.model.doc.cuerpo.cc_id_204[this.modelForm.id].v = this.modelForm.desc;
    this.model.doc.cuerpo.cc_id_205[this.modelForm.id].v = this.modelForm.origen;
    this.model.doc.cuerpo.cc_id_206[this.modelForm.id].v = this.modelForm.anioCompra;
    this.model.doc.cuerpo.cc_id_207[this.modelForm.id].v = this.modelForm.valCompra;
    this.model.doc.cuerpo.cc_id_208[this.modelForm.id].v = this.modelForm.valDeclaradoAnioAnterior;
    this.model.doc.cuerpo.cc_id_209[this.modelForm.id].v = this.modelForm.valAjustadoArt70;
    this.model.doc.cuerpo.cc_id_210[this.modelForm.id].v = this.modelForm.valAjustadoArt73;
    this.model.doc.cuerpo.cc_id_211[this.modelForm.id].v = this.modelForm.valDeclarar;
  }

  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;
    this.model.doc.cuerpo.cc_id_204.push({ it: i, v: this.modelForm.desc });
    this.model.doc.cuerpo.cc_id_205.push({ it: i, v: this.modelForm.origen });
    this.model.doc.cuerpo.cc_id_206.push({ it: i, v: this.modelForm.anioCompra });
    this.model.doc.cuerpo.cc_id_207.push({ it: i, v: this.modelForm.valCompra });
    this.model.doc.cuerpo.cc_id_208.push({ it: i, v: this.modelForm.valDeclaradoAnioAnterior });
    this.model.doc.cuerpo.cc_id_209.push({ it: i, v: this.modelForm.valAjustadoArt70 });
    this.model.doc.cuerpo.cc_id_210.push({ it: i, v: this.modelForm.valAjustadoArt73 });
    this.model.doc.cuerpo.cc_id_211.push({ it: i, v: this.modelForm.valDeclarar });
  }

  public deleteOnModel(index: number) {
    this.model.doc.cuerpo.cc_id_204.splice(index, 1);
    this.model.doc.cuerpo.cc_id_205.splice(index, 1);
    this.model.doc.cuerpo.cc_id_206.splice(index, 1);
    this.model.doc.cuerpo.cc_id_207.splice(index, 1);
    this.model.doc.cuerpo.cc_id_208.splice(index, 1);
    this.model.doc.cuerpo.cc_id_209.splice(index, 1);
    this.model.doc.cuerpo.cc_id_210.splice(index, 1);
    this.model.doc.cuerpo.cc_id_211.splice(index, 1);

    //reenumerear it
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_204.length; i++) {
      this.model.doc.cuerpo.cc_id_204[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_205[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_206[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_207[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_208[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_209[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_210[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_211[i].it = i + 1;
    }
  }

  public validateFormCompleted(): boolean {
    return this.modelForm.desc == undefined || this.modelForm.desc == null || this.modelForm.desc.trim() == "" ||
      this.modelForm.valCompra == undefined || this.modelForm.valCompra == "0" ||
      this.modelForm.anioCompra == undefined || this.modelForm.anioCompra == "0" ||
      this.modelForm.valDeclaradoAnioAnterior == undefined ||this.modelForm.valDeclaradoAnioAnterior == "" ||
      this.modelForm.valDeclarar == undefined || this.modelForm.valDeclarar == "0" || this.modelForm.valDeclarar == "" ||
      this.modelForm.origen == undefined || this.modelForm.origen == null;
  }

  public redondearFormData() {
    this.modelForm.valCompra = this.dutilidades.redondearValorMoneda(this.modelForm.valCompra.toString(), true);
    this.modelForm.valDeclaradoAnioAnterior = this.dutilidades.redondearValorMoneda(this.modelForm.valDeclaradoAnioAnterior.toString(), true);
  }

  public calcularValoresForm(conservarArt?: boolean) {
    this.redondearFormData();
    this.modelForm.valAjustadoArt70 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.valDeclaradoAnioAnterior.toString(), "1.1240", true);
    this.modelForm.valAjustadoArt70 = this.dutilidades.redondearValorMoneda(this.modelForm.valAjustadoArt70.toString(), true);
    if (this.modelForm.aplicoArt73 == "1") {
      let registroArt73 = this.tablaArt73.find((ite: any) => (this.modelForm.anioCompra == ite.anio && this.anioDeclaracion == ite.anioGravable));
      let resultado = registroArt73? this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.valCompra.toString(), registroArt73.acciones.toString(), false):'0';
      this.modelForm.valAjustadoArt73 = resultado;
      this.modelForm.valAjustadoArt73 = this.dutilidades.redondearValorMoneda(this.modelForm.valAjustadoArt73.toString(), true);
    } else {
      this.modelForm.valAjustadoArt73 = "0";
    }
    this.modelForm.valAjustadoArt73 = this.dutilidades.redondearValorMoneda(this.modelForm.valAjustadoArt73.toString(), true);

    switch (Number(this.modelForm.art)) {
      case 1:
        //Nada
        break;
      case 2:
        this.modelForm.valDeclarar = this.modelForm.valCompra.toString();
        break;
      case 3:
        this.modelForm.valDeclarar = this.modelForm.valDeclaradoAnioAnterior.toString();
        break;
      case 4:
        this.modelForm.valDeclarar = this.modelForm.valAjustadoArt70.toString();
        break;
      case 5:
        this.modelForm.valDeclarar = this.modelForm.valAjustadoArt73.toString();
        break;
      default:
        this.modelForm.valDeclarar = "0";
    }
    this.modelForm.valDeclarar = this.dutilidades.redondearValorMoneda(this.modelForm.valDeclarar.toString(), true);
    this.reloadSelArticulos(conservarArt);
  }

  saveItem(): void {
    if (this.validateFormCompleted()) {
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro");
      return;
    } else {
      this.redondearFormData();
      if (this.operacionTabla == this.OPERACION_EDITAR) {
        
        // const existeValor = this.model.doc.cuerpo.cc_id_204.some(item => item.v === this.modelForm.desc);
        // if (this.modelForm.origen == "2" || this.modelForm.origen == "1" || (existeValor && this.modelForm.origen == "0")) { //editando contribuyente o editando sugerida
        //   this.modelForm.origen = this.modelForm.origen == "0" ? "1" : this.modelForm.origen;
        //   this.editModeloDesdeForm();
        // } else if (this.modelForm.origen == "0") { //editando sugerida
        //   this.modelForm.origen = "1";
        //   this.modelForm.id = this.model.doc.cuerpo.cc_id_204.length;
        //   this.addToModeloDesdeForm();
        // }
        // this.editModeloDesdeForm();




        if(this.modelForm.origen=="0"){ 
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });

      } else if (this.operacionTabla == this.OPERACION_AGREGAR) {//agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_204.length;
        this.modelForm.origen = "2";
        this.modelForm.reportante = "Contribuyente";
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs156();
      this.inicializeForm();
      this.operacionTabla = this.OPERACION_NULA;
      console.log(this.model);
    }
  }

  eventTable($event: string): void {
    if ($event === 'add') this.operacionTabla = this.OPERACION_AGREGAR;
    if ($event === 'edit') this.operacionTabla = this.OPERACION_EDITAR;
    if ($event === 'delete') this.operacionTabla = this.OPERACION_BORRAR;
    this.operacionCs156();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if (this.operacionTabla == this.OPERACION_EDITAR) {//editando
      this.modelForm = this.dataSourceBody[index];
      this.reloadSelArticulos(true);
    }
    if (this.operacionTabla == this.OPERACION_BORRAR) {//borrando
      //this.deleteOnModel(index);
      this.operacionTabla = this.OPERACION_NULA;
      console.log(this.model);
    }
  }

  cancel(): void {
    this.inicializeForm();
    this.operacionTabla = this.OPERACION_NULA;
  }


  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO
  // public validateRbQuestions(val: string) {
  //   this.modelForm.aplicoArt73 = val;
  //   this.calcularValoresForm();
  // }

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion: number): boolean {
    let hasValues: boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal: number) {

  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  // public validateStepHabilitado(indexS:number):boolean{
  //   let habilitado = true;
  //   return habilitado;
  // }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  // public validateBtnRightActive(){

  // }

  //////////////////////////

  protected obtenerCasIndicadorAvance(): string {
    if (this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == undefined) {
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = "0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected validateShowSave() {
    if (this.indexStepper == this.stepsList.length - 1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == VAL_INDICADOR_COMPLETO) { this.showSave = true };
  }

  public closeModal() {
    this.initializeTablaDesdeModelo();
    this.operacionCs156();
    // this.changeStepLocal(0);
    this.dialogRef.close("");
  }
  public guardar() {

        //Limpiar modelo y agregar el contenido de la tabla
        this.model.doc.cuerpo.cc_id_204 = undefined;
        this.inicializeModelo();
        for(let i=0; i<this.dataSourceBody.length; i++){
          this.modelForm = this.dataSourceBody[i];
          this.addToModeloDesdeForm();
        }
        this.operacionCs156();
    // if (this.model.doc.cuerpo.cc_id_204.length != this.dataSourceBody.length) {
    //   for (let i = 0; i < this.dataSourceBody.length; i++) {
    //     const existeValor = this.model.doc.cuerpo.cc_id_204.some(item => item.v === this.dataSourceBody[i].desc);
    //     if (!existeValor && this.dataSourceBody[i].origen == "0") {
    //       this.modelForm = this.dataSourceBody[i];
    //       this.addToModeloDesdeForm();

    //     }


    //   }
    // }
    this.saveModel.emit(true);
    // if(this.indexStepper==this.stepsList.length-1){
    this.closeModal();
    // }
  }
  public borrarTabla() {
    this.dataSourceBody = [];
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-acciones-modal/patrimonio-acciones-modal.component.ts